module.exports = __webpack_public_path__ + "img/kiosk-place-de-la-cite-home.11623007.webp";